import { signOut } from "@/common/lib/auth";
import { queryClient } from "@/common/lib/queryClient";
import { clearCurrentAccountId } from "@/features/accounts/hooks/useCurrentAccount";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export function useLogout() {
  const navigate = useNavigate();

  return useCallback(async () => {
    clearCurrentAccountId();
    queryClient.clear();
    await signOut();
    navigate("/login", { replace: true });
  }, [navigate]);
}
